var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Time Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 13.6668C3.31998 13.6668 0.333313 10.6868 0.333313 7.00016C0.333313 3.32016 3.31998 0.333496 6.99998 0.333496C10.6866 0.333496 13.6666 3.32016 13.6666 7.00016C13.6666 10.6868 10.6866 13.6668 6.99998 13.6668ZM9.12668 9.47345C9.20668 9.52012 9.29335 9.54678 9.38668 9.54678C9.55335 9.54678 9.72002 9.46012 9.81335 9.30012C9.95335 9.06678 9.88002 8.76012 9.64002 8.61345L7.26668 7.20012V4.12012C7.26668 3.84012 7.04002 3.62012 6.76668 3.62012C6.49335 3.62012 6.26668 3.84012 6.26668 4.12012V7.48678C6.26668 7.66012 6.36002 7.82012 6.51335 7.91345L9.12668 9.47345Z",
    fill: "#6C53E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.a84e988c4130144a8f396d812281a50f.svg";
export { ForwardRef as ReactComponent };